import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { ArrowUpIcon, ShareNowFilledIcon, VisibilityFilledIcon } from '@change/ds-icons';

import { TranslatePlural, TranslatePluralHtml } from '@change-corgi/core/react/i18n';

import { Speedometer } from './components/Speedometer';
import { usePetitionStats } from './hooks/usePetitionStats';

export const PetitionStats: React.FC = () => {
	const { data } = usePetitionStats();

	return (
		<div className="flex h-full flex-col gap-4">
			<div className="grid h-full w-full grid-cols-[1fr] gap-0 border-[unset] bg-white md:pl-0 xl:grid-cols-[auto_auto] xl:gap-8">
				<div className="relative grid min-w-60 justify-center gap-[13px]" data-qa="circular-progress-bar">
					<Speedometer />
					<Text className="w-full max-w-60 text-center">
						<TranslatePluralHtml
							value="corgi.petition.starter_dashboard.petition_overview.progress.num_to_goal"
							count={data.signaturesToGoal}
							replacements={{
								number: data.signaturesToGoalFormatted,
							}}
						/>
					</Text>
				</div>

				<div className="hidden w-full items-center justify-center xl:flex">
					<div className="flex flex-col gap-4 lg:gap-4">
						<div data-testid="view-count" className="flex items-center gap-2 [word-break:auto-phrase]">
							<VisibilityFilledIcon className="text-icon-selected" />
							<Text>
								<TranslatePlural
									value="corgi.petition.starter_dashboard.petition_overview.stats.views"
									count={data.views}
									replacements={{ viewCount: data.viewsFormatted }}
								/>
							</Text>
						</div>
						<div data-testid="share-count" className="flex items-center gap-2 [word-break:auto-phrase]">
							<ShareNowFilledIcon className="text-icon-selected" />
							<Text>
								<TranslatePlural
									value="corgi.petition.starter_dashboard.petition_overview.stats.shares"
									count={data.shares}
									replacements={{ shareCount: data.sharesFormatted }}
								/>
							</Text>
						</div>
						{data.shouldShowPromotions && (
							<div data-testid="promote-count" className="flex items-center gap-2 [word-break:auto-phrase]">
								<ArrowUpIcon className="text-icon-selected" />
								<Text>
									<TranslatePlural
										value="corgi.petition.starter_dashboard.petition_overview.stats.promoters"
										count={data.promoters}
										replacements={{ promoterCount: data.promotersFormatted }}
									/>
								</Text>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
